document.addEventListener('DOMContentLoaded', () => {
    const switcherContent = () => {
        const container = document.querySelectorAll('.js-switcher-content-wrapper');
        container.forEach(con => {
            const btnAction = con.querySelectorAll('.js-switcher-content-nav');
            const contents = con.querySelectorAll('.js-switcher-content');
            btnAction.forEach(el => {
                el.addEventListener('click', (e) => {
                    contents.forEach(el => el.classList.remove('is-active'));
                    btnAction.forEach(el => el.classList.remove('is-active'));
                    
                    //add return top section
                    if (el.classList.contains('js-scroll-top-se')) {
                        if (el.closest('section')) {
                            scroll({
                                top: el.closest('section').offsetTop,
                                behavior: "smooth"
                            });
                        }
                    }
                    let target = e.currentTarget.getAttribute('data-target');
                    let content = con.getElementsByClassName(target)[0];
                    e.currentTarget.classList.add('is-active');
                    content.classList.add('is-active');
                });

            });
        });
    };

    switcherContent();

});